import { useMemo } from 'react';
import { Campus } from '../../../../types/campus';
import { Schedule } from '../../../../types/schedule';

export function useContinuousEducationSectionEditForm(
  campuses: Campus[],
  schedules: Schedule[],
) {
  const campusOptions = useMemo(() => {
    return campuses.map((row: Campus) => ({
      value: row.id,
      label: row.name,
    }));
  }, [campuses]);

  const schedulesOptions = useMemo(() => {
    return schedules.map((row: Schedule) => ({
      value: row.id ?? '',
      label: row.name,
    }));
  }, [schedules]);

  return {
    campusOptions,
    schedulesOptions,
  };
}
